import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { BookOpen, User, Award } from 'lucide-react';
import axios from 'axios';

import styles from './AuthorDatails.module.css';

import NotFound from '../../pages/NotFound'
import Loading from '../../components/Loading';
import CardBook from '../../components/CardBook';

export default function AuthorDetails() {
  const [author, setAuthor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(false);

  const { id } = useParams();

  useEffect(() => {
    axios.get(`https://back-cultura-sje-production.up.railway.app/get-author/${id}`, {})
      .then((response) => {
        setAuthor(response.data)})
      .catch((error) => {
        console.error('Erro ao buscar autor', error);
      })
      .finally(() => {
        setTimeout(() => setLoading(false), 500);
      });
  }, [id]);

  if (loading) {
    return <Loading />
  }

  if (!author) {
    return <NotFound />;
  }
  
  return (
    <main className={styles.page}>
      <div className={styles.container}>
        <div className={styles.authorCard}>
          <div className={styles.authorHeader}>
            <img 
              src={author.foto}
              alt={`Foto de ${author.nomeArtistico}`}
              className={styles.authorImage}
            />
            
            <div className={styles.authorInfo}>
              <h1 className={styles.authorName}>
                {author.nomeArtistico}
              </h1>
              
              <div className={styles.genreSection}>
                <div className={styles.sectionTitle}>
                  <Award size={20} />
                  Gêneros Literários:
                </div>
                <div className={styles.genreList}>
                  {Array.isArray(author.generoLiterario) &&
                    author.generoLiterario.map((genero, index) => (
                      <span key={index} className={styles.genreTag}>{genero}</span>
                    ))
                  }
                </div>
              </div>
            </div>
          </div>
          
          <div className={styles.biographySection}>
            <div className={styles.sectionTitle}>
              <User size={20} />
              Biografia
            </div>
            <p className={styles.biography}>
              {expanded 
                ? author.biografia 
                : `${author.biografia?.slice(0, 300)}${author.biografia?.length > 300 ? '...' : ''}`}
            </p>

            {author.biografia?.length > 300 && (
              <button 
                className={styles.toggleButton} 
                onClick={() => setExpanded(!expanded)}
              >
                {expanded ? '...Ver menos' : 'Ver mais...'}
              </button>
            )}
          </div>
        </div>
        
        <div className={styles.booksSection}>
          <h2 className={styles.booksTitle}>
            <BookOpen size={24} />
            Obras de Sua Autoria
          </h2>
          
          <div className={styles.booksContainer}>
            {author && author.livros && author.livros.length > 0 ? (
              author.livros.map((livro) => (
                <Link to={`/autores/livros/${livro.id}`} className={styles.bookLink}>
                  <CardBook 
                    titulo={livro.titulo}
                    genero={livro.genero}
                    capa={livro.capa}
                    preco={livro.preco}
                  />
                </Link>
              ))
            ) : (
              <p>Esse autor ainda não tem livros cadastrados.</p>
            )}
          </div>
        </div>
      </div>
    </main>
  );
}